"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Course_template = require("./components/Course/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Course_tag = marko_loadTag(Course_template),
    Activity_template = require("./components/Activity/index.marko"),
    Activity_tag = marko_loadTag(Activity_template),
    Switch_template = require("../../../../components/Switch/index.marko"),
    Switch_tag = marko_loadTag(Switch_template),
    Wrapper_template = require("../../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template);

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      renderBody: function(out) {
        Switch_tag({
            by: input.params.type,
            case: [
                {
                    is: "course",
                    renderBody: function(out) {
                      Course_tag({
                          params: input.params
                        }, out, __component, "3");
                    }
                  },
                {
                    is: "program",
                    renderBody: function(out) {
                      Course_tag({
                          params: input.params,
                          within: "program"
                        }, out, __component, "5");
                    }
                  },
                {
                    is: "activity",
                    renderBody: function(out) {
                      Activity_tag({
                          params: input.params
                        }, out, __component, "7");
                    }
                  }
              ]
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
